import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { axiosPost } from '../../../utils/axiosPost';
import { strapiUrl } from '../../../utils/constants';
import { devError } from '../../../utils/devLog';

const CouncilPDFDownloadButton = ({ onNotification }) => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState(null);

  const handleGenerate = async () => {
    setIsGenerating(true);
    setDownloadUrl(null);

    try {
      const response = await axiosPost('committee-pdf/generate-council-zip', {
        data: {
          includeAllRanked: false,
        },
      });

      if (response?.status === 200 && response.data?.url) {
        setDownloadUrl(response.data.url);

        if (onNotification) {
          onNotification(
            'PDFs Generated Successfully',
            `All ranked candidates' PDFs have been compiled into a zip file.`,
            'fa-check-circle',
            'text-success',
          );
        }
      } else {
        throw new Error('Invalid response from server');
      }
    } catch (error) {
      devError('PDF generation error:', error);

      if (onNotification) {
        onNotification(
          'PDF Generation Failed',
          'Failed to generate PDFs. Please try again or contact support.',
          'fa-exclamation-circle',
          'text-danger',
        );
      } else {
        alert('Failed to generate PDFs. Please try again.');
      }
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="d-flex justify-content-center mt-xl-5 mb-4">
      {downloadUrl ? (
        <Button
          variant="success"
          href={`${strapiUrl}${downloadUrl}`}
          download
          className="standard-width-button d-flex align-items-center gap-2"
          as="a"
        >
          <i className="fas fa-download" />
          Download All PDFs
        </Button>
      ) : (
        <Button
          variant="primary"
          onClick={handleGenerate}
          disabled={isGenerating}
          className="standard-width-button d-flex align-items-center gap-2"
        >
          <i
            className={`fas ${isGenerating ? 'fa-sync fa-spin' : 'fa-file-archive'}`}
          />
          {isGenerating
            ? 'Generating PDFs...'
            : 'Generate Recommended to Council PDFs'}
        </Button>
      )}
    </div>
  );
};

CouncilPDFDownloadButton.propTypes = {
  onNotification: PropTypes.func,
};

export default CouncilPDFDownloadButton;
